import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { createStyles, Title, Space, Card, Text, Group, LoadingOverlay, ActionIcon, Textarea } from "@mantine/core";
import { useGlobalSurveysProvider } from "../../contexts/global-surveys.context";
import { IconSearch, IconX } from "@tabler/icons-react";
import MiniBarPlot from "../../components/mini-bar-plot/mini-bar-plot.component";
import MiniLinePlot from "../../components/mini-line-plot/mini-line-plot.component";

const plotDimensions = 70;

const useStyles = createStyles((theme, _params, getRef) => ({
    background: {
        minHeight: 'calc(100vh - 55px)',
    },

    galleryContainer: {
        // maxWidth: '1400px',
        padding: '0px 20px',
        margin: '0px auto',
    },

    surveyCard: {
        height: '230px',
        flexGrow: 1,
        minWidth: '200px',
        maxWidth: '49%',
        border: `1px solid ${theme.colors.gray[5]}`,
        // boxShadow: lightBoxShadowNonHover,
        // boxShadow: `7px 7px 0px 0px ${theme.colors.gray[3]}`,
        grow: 1,
        '&:hover': {
            // boxShadow: lightBoxShadowHover,
            // Scale up 1.2x
            transform: 'scale(1.02)',
            // boxShadow: `5px 5px 0px 0px ${theme.colors.gray[4]}`,
        },
        [`@media (min-width: 1850px)`]: {
            maxWidth: '32%',
        },
        [`@media (max-width: 920px)`]: {
            width: '100%',
            maxWidth: '100%',
            height: 'initial',
        },
    },

    searchBar: {
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
        borderRadius: '16px',
        '.mantine-Input-rightSection': {
            marginRight: '5px',
        },
        [`@media (max-width: 1120px)`]: {
            maxWidth: '350px',
        },
        [`@media (max-width: 1060px)`]: {
            maxWidth: '290px',
        },
        [`@media (max-width: 1000px)`]: {
            maxWidth: '100%',
        },
        // Stick position
        position: 'sticky',
        top: '5px',
        zIndex: '9999999',
        // boxShadow: '0px 0px 25px rgba(0,0,0,0.3)',
    },

    desktopOnly: {
        [theme.fn.smallerThan('sm')]: {
            display: 'none',
        }
    },

    surveyTitle: {
        display: '-webkit-box',
        maxWidth: '100%',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.4,
    },

    answerText: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    descriptionText: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    cardsContainer: {
        position: 'relative',
        minHeight: '265px', // Same as card height
    },

    modelText: {
        background: '#f5f5f5',
        display: 'block',
        padding: '6px',
        borderRadius: '12px',
        position: 'absolute',
        bottom: '20px',
        right: '20px',
    },

    plotWrapper: {
        display: 'flex',
        // background: 'pink',
        width: `${plotDimensions}px`,
        height: `${plotDimensions}px`,
        position: 'absolute',
        bottom: '20px',
        left: '20px',
        [`@media (max-width: 920px)`]: {
            position: 'relative',
            marginTop: '30px',
            left: '0px',
        },
    },

}));

const searchHandler = (surveys, searchString) => {
    // Scroll to top
    window.scrollTo(0, 0);
    if (searchString === '') return surveys;
    const lowerCaseSearchString = searchString.toLowerCase();
    const shownSurveys = surveys.filter(survey => {
        if (survey.surveyQuestion.toLowerCase().includes(lowerCaseSearchString)) return true;
        // if (survey.hasOwnProperty('surveyDescriptions') && survey.surveyDescriptions.length > 0) {
        //     for (let description of survey.surveyDescriptions) {
        //         if (description.toLowerCase().includes(lowerCaseSearchString)) return true;
        //     }
        // }
        // if (survey.hasOwnProperty('customQuestionsAndResponses') && survey.customQuestionsAndResponses.length > 0) {
        //     for (let questionAndResponse of survey.customQuestionsAndResponses) {
        //         if (questionAndResponse.question.toLowerCase().includes(lowerCaseSearchString)) return true;
        //         // Check response
        //         if (questionAndResponse.response.toLowerCase().includes(lowerCaseSearchString)) return true;
        //         // Loop through options and check
        //         if (questionAndResponse.hasOwnProperty('options') && questionAndResponse.options.length > 0) {
        //             for (let option of questionAndResponse.options) {
        //                 if (option.toLowerCase().includes(lowerCaseSearchString)) return true;
        //             }
        //         }
        //     }
        // }
        if (survey.hasOwnProperty('surveyAnswers')) {
            for (let answer of survey.surveyAnswers) {
                if (answer.toLowerCase().includes(lowerCaseSearchString)) return true;
            }
        }
        return false;

    });
    return shownSurveys;
}


// const getDescriptionText = (description) => {
//     let descriptionText = ' ';
//     if (description.length > 0) {
//         description.forEach((text, index) => {
//             descriptionText += text;
//             if (index !== description.length - 1) descriptionText += ', ';
//         });
//     } else {
//         descriptionText += 'None';
//     }
//     return descriptionText;
// }

// const getConditioningQuestionsText = (conditioningQuestions) => {
//     let conditioningQuestionsText = ' ';
//     if (conditioningQuestions.length > 0) {
//         conditioningQuestions.forEach((text, index) => {
//             conditioningQuestionsText += text.question;
//             if (index !== conditioningQuestions.length - 1) conditioningQuestionsText += ', ';
//         });
//     } else {
//         conditioningQuestionsText += 'None';
//     }
//     return conditioningQuestionsText;
// }

const url = window.location.hostname;

const Showcase = () => {

    const { gallerySurveys, setGallerySurveys, setGallerySurveysLoaded } = useGlobalSurveysProvider();
    const { classes } = useStyles();
    const [shownGallerySurveys, setShownGallerySurveys] = useState(gallerySurveys);
    const [searchString, setSearchString] = useState('');
    const [highlightedSurvey, setHighlightedSurvey] = useState(null);

    useEffect(() => {

        const getShowcaseSurveysOnLoad = async () => {
            const surveys = await fetch("/.netlify/functions/getShowcaseSurveys", { method: "POST" });
            const { loadedGallerySurveys } = await surveys.json();
            setGallerySurveys(loadedGallerySurveys);
            setShownGallerySurveys(loadedGallerySurveys);
            setGallerySurveysLoaded(true);
        }
        getShowcaseSurveysOnLoad();

    }, []);

    useEffect(() => {
        const searchedSurveys = searchHandler(gallerySurveys, searchString);
        setShownGallerySurveys(searchedSurveys);
    }, [searchString]);


    return (
        <>
            <Helmet>
                <title>Showcase | Roundtable</title>
                <meta name='description' content="View example simulated surveys from the Roundtable platform." />
            </Helmet>
            <div className={classes.background}>
                <div className={classes.galleryContainer}>
                    <Space h='xl' />
                    <Space h='xl' className={classes.desktopOnly} />
                    <Title order={1} align="center" weight={500}>Roundtable Showcase</Title>
                    <Space h='xl' />
                    <Textarea
                        className={classes.searchBar}
                        placeholder='Search surveys...'
                        size='sm'
                        maxLength='500'
                        autosize
                        radius='lg'
                        onChange={(e) => { setSearchString(e.target.value) }}
                        icon={<IconSearch size={20} stroke={1.5} />}
                        // Custom styling
                        rightSection={
                            <ActionIcon
                                hidden={searchString === ''}
                                size={32}
                                radius="xl"
                                className={classes.searchCrossIcon}
                                onMouseDown={() => { setSearchString('') }}
                            >
                                <IconX size={20} stroke={1.5} />
                            </ActionIcon>
                        }
                    />
                    <Space h='xl' />
                    <Space h='xl' className = {classes.desktopOnly} />
                    <Group position='center' className={classes.cardsContainer}>
                        <LoadingOverlay visible={gallerySurveys.length === 0} overlayOpacity={0} />
                        {
                            shownGallerySurveys.length !== 0 && shownGallerySurveys.map(survey => (
                                <Card
                                    className={classes.surveyCard}
                                    key={survey.id}
                                    px="lg"
                                    py={0}
                                    component="a"
                                    radius='lg'
                                    href={`${url === 'localhost' ? 'localhost:8888' : 'https://app.roundtable.ai'}/simulator/${survey.id}`}
                                    target="_blank"
                                    withBorder
                                    onMouseEnter={() => { setHighlightedSurvey(survey.id) }}
                                    onMouseLeave={() => { setHighlightedSurvey(null) }}
                                >
                                    <Space h={20} />
                                    {/* <Space h='sm' /> */}
                                    <Text className={classes.surveyTitle} weight={400} size="lg">
                                        {survey.surveyQuestion}
                                    </Text>
                                    <Space h={5} />
                                    <Text color="dimmed" size="sm" className={classes.answerText}>
                                        {
                                            survey.surveyAnswers.map((answer, i) => (
                                                <Text key={answer} component='span'>
                                                    {answer}{i === survey.surveyAnswers.length - 1 ? '' : ', '}
                                                </Text>
                                            )
                                            )
                                        }
                                    </Text>
                                    <Space h={5} />
                                    {/* <Text size='sm' className={classes.descriptionText}>
                                        <Text component='span' weight={500}>
                                            Descriptions:
                                        </Text>
                                        {getDescriptionText(survey.surveyDescriptions)}
                                    </Text>
                                    <Text size='sm' className={classes.descriptionText}>
                                        <Text component='span' weight={500}>
                                            Conditioning questions:
                                        </Text>
                                        {getConditioningQuestionsText(survey.customQuestionsAndResponses)}
                                    </Text> */}
                                    {/* <Space h='xs' /> */}
                                    {/* <Text size='sm'>{
                                        survey.surveyYears[0] === survey.surveyYears[1] ?
                                            survey.surveyYears[0] :
                                            `${survey.surveyYears[0]} - ${survey.surveyYears[1]}`
                                    }
                                    </Text> */}
                                    <Space h={5} />
                                    <Text size='xs' className={classes.modelText}>
                                        Multiple-choice
                                    </Text>
                                    <div className={classes.plotWrapper}>
                                        <svg>
                                        {
                                            survey.surveyData.length > 1 ?
                                                <MiniLinePlot
                                                    plotHeight={plotDimensions}
                                                    plotWidth={plotDimensions}
                                                    yearData={survey.surveyData}
                                                    marginForEachSide={0}
                                                    surveyAnswers = {survey.surveyAnswers}
                                                    opacity = {highlightedSurvey === survey.id ? 0.75 : 0.55}
                                                />
                                                :
                                                <MiniBarPlot
                                                    plotHeight={plotDimensions}
                                                    plotWidth={plotDimensions}
                                                    yearData={survey.surveyData}
                                                    marginForEachSide={0}
                                                    surveyAnswers = {survey.surveyAnswers}
                                                    opacity = {highlightedSurvey === survey.id ? 0.75 : 0.55}
                                                />
                                        }
                                        </svg>
                                        {/* <Text size='xs' className={classes.modelText}>
                                            GSS
                                        </Text> */}
                                    </div>
                                </Card>
                            ))
                        }
                    </Group>
                    <Space h='xl' />
                    <Space h='xl' />
                </div>
            </div>
        </>
    );
}

export default Showcase;

// To do
// Add padding